module.exports = __webpack_public_path__ + "img/icon_arrow_left_black.fd4e0190.svg";